module.exports = __webpack_public_path__ + "static/pid-ug-3-en-confirmauthcode-f1983888b44a81aa9821e4de4d93fef6.png";